export enum WriteOnEdgeStatusEnum {
  CREATED = "CREATED",
  RUNNING = "RUNNING",
  COMPLETED_OK = "COMPLETED_OK",
  COMPLETED_KO = "COMPLETED_KO",
  COMPLETED_TIMEOUT = "COMPLETED_TIMEOUT"
}
